import { HIERARCHY_LEVEL } from '@atlassian/jira-admin-pages-issue-types-common/src/constants.tsx';
import { DESC } from '@atlassian/jira-common-constants/src/sort-directions.tsx';
import type { Filter } from './types.tsx';

export const MAX_RESULTS = 15;

export const DEFAULT_FILTER: Filter = {
	page: 1,
	sortDirection: DESC,
	sortField: HIERARCHY_LEVEL,
};
